import confetti from 'canvas-confetti';


const FIREWORKS_ORIGIN = {
  left: {
    x: {
      min: 0.1,
      max: 0.3,
    },
    y: { offset: 0.2 },
  },
  right: {
    x: {
      min: 0.7,
      max: 0.9,
    },
    y: { offset: 0.2 },
  },
};

const DURATION = 15000;
const INTERVAL_DELAY = 250;
const DEFAULT_CONFIG = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 1000 };

function randomInRange(min, max) {
  const range = max - min;
  const randomNum = Math.random() * range;

  return randomNum + min;
}

const triggerFireworks = () => {
  const animationEndTime = Date.now() + DURATION;

  // eslint-disable-next-line consistent-return
  const interval = setInterval(() => {
    const timeLeft = animationEndTime - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const defaultCount = 50;
    const particleCount = defaultCount * (timeLeft / DURATION);

    const leftSideOrigin = {
      x: randomInRange(FIREWORKS_ORIGIN.left.x.min, FIREWORKS_ORIGIN.left.x.max),
      y: Math.random() - FIREWORKS_ORIGIN.left.y.offset,
    };
    const leftSideConfig = {
      ...DEFAULT_CONFIG,
      particleCount,
      origin: leftSideOrigin,
    };

    const rightSideOrigin = {
      x: randomInRange(FIREWORKS_ORIGIN.right.x.min, FIREWORKS_ORIGIN.right.x.max),
      y: Math.random() - FIREWORKS_ORIGIN.right.y.offset,
    };
    const rightSideConfig = {
      ...DEFAULT_CONFIG,
      particleCount,
      origin: rightSideOrigin,
    };

    confetti(leftSideConfig);
    confetti(rightSideConfig);
  }, INTERVAL_DELAY);
};

export { triggerFireworks };
